import {
  REQUEST_LAST_ASSIGNED_CLAIMS,
  SET_LAST_ASSIGNED_CLAIMS,
  SET_SEARCH_QUERY,
  SET_SELECTED_RESULT_SEARCH,
  RESET_STORE_SEARCH,
} from 'containers/ManagerHomePage/constants';

export const requestLastAssignedClaims = (payload: {}) => ({
  type: REQUEST_LAST_ASSIGNED_CLAIMS,
  payload,
});

export const setLastAssignedClaims = (payload: {}) => ({
  type: SET_LAST_ASSIGNED_CLAIMS,
  payload,
});
export const setSearchQueryMonitoringManager = (payload: {}) => ({
  type: SET_SEARCH_QUERY,
  payload,
});

export const setSelectedResultSearch = (payload: {}) => ({
  type: SET_SELECTED_RESULT_SEARCH,
  payload,
});
export const resetStoreSearch = () => ({
  type: RESET_STORE_SEARCH,
});
